import { render, staticRenderFns } from "./groupListMod.vue?vue&type=template&id=11bdd82a&scoped=true&"
import script from "./groupListMod.vue?vue&type=script&lang=js&"
export * from "./groupListMod.vue?vue&type=script&lang=js&"
import style0 from "./groupListMod.vue?vue&type=style&index=0&id=11bdd82a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bdd82a",
  null
  
)

export default component.exports